import React from 'react';
import { jsx } from '@emotion/core';
import LectureComponentBaseModel from 'lecture_pages/services/components/lecture-component-base-model';

// make sure to wrap your component and override these values
const lectureComponentContext = React.createContext({
  lectureComponentId: -1,
  lecturePageId: -1,
  catalogId: '',
  isEdit: false,
  angularComponent: null,
});

interface LectureComponentProviderProps {
  lectureComponentId: number;
  lecturePageId: number;
  catalogId: string;
  isEdit: boolean;
  angularComponent: InstanceType<ReturnType<typeof LectureComponentBaseModel>>;
}

/* @ngInject */
export default function LectureComponentProvider(props: React.PropsWithChildren<LectureComponentProviderProps>) {
  const value = React.useMemo(
    () => ({
      lectureComponentId: props.lectureComponentId,
      lecturePageId: props.lecturePageId,
      catalogId: props.catalogId,
      isEdit: props.isEdit,
      angularComponent: props.angularComponent,
    }),
    [props.catalogId, props.isEdit, props.lectureComponentId, props.lecturePageId, props.angularComponent],
  );

  return <lectureComponentContext.Provider value={value}>{props.children}</lectureComponentContext.Provider>;
}

/* @ngInject */
export function useLectureComponentContext() {
  return React.useContext(lectureComponentContext);
}

